var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"progress"},[_c('el-link',{attrs:{"underline":false}},[_vm._v("文件上传进度")]),_c('el-progress',{attrs:{"text-inside":true,"stroke-width":20,"percentage":_vm.percentage,"status":"success"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }